import { useContext } from 'react';
import fileDownload from 'js-file-download';

import config from 'app/src/config';
import ClientContext from 'app/src/contexts/ClientContext';

const useRest = () => {
  const { credentials } = useContext(ClientContext);

  const rest = ({ path }) => {
    const url = new URL(`${config.api.baseUri}/${path}`);

    const headers = {
      'Content-Type': 'application/json',
      Accept: '*/*',
      'access-token': credentials.accessToken,
      ...credentials,
    };

    return fetch(url, { headers });
  };

  const download = ({ path, extension }) => {
    const filename = path.split('/')[path.split('/').length - 1];
    const timestamp =
      new Date().toISOString().replace(/[-T:]/g, '').split('.')[0]
    const filenameWithTimestamp = `${filename}-${timestamp}.${extension}`;

    rest({ path }).then(response => {
      response.blob().then(blob => fileDownload(blob, filenameWithTimestamp));
    });
  }

  return { rest, download };
};

export default useRest;
